import { AxiosResponse } from 'axios';
import { useSelector } from 'react-redux';

import { createServiceInstance } from '../baseService';
import {
  IGetIndividualActiveSubmissionResponse,
  IUserDetailsResponse
} from './userServiceTypes';

/**
 * User service model
 * @description Returns object with user services
 * @typedef {object} IUserService
 */
export interface IUserService {
  getUserDetails: () => Promise<AxiosResponse<IUserDetailsResponse>>;
  getActiveSubmissions: () => Promise<AxiosResponse<IGetIndividualActiveSubmissionResponse>>;
}

/**
 * User service hook
 * @description Gives access to all services relating to user
 */
const useUserService = () : IUserService => {
  const token = useSelector((state: any) => state.B2CSettings.items.accesstokenForms);
  const webappurlPortalApi =  useSelector((state: any) => state.B2CSettings.items.webappurlPortalApi);

  const getInstance = () => createServiceInstance(`${webappurlPortalApi}/api/myCASA/Portal`, token);

  /**
   * Get User details
   * @description Get details for given user from CRM
   *
   */
  const getUserDetails = () => {
    const axiosInstance = getInstance();

    return axiosInstance.post<IUserDetailsResponse>('/GetUserDetails/v1', null);
  };

  /**
   * Get User details
   * @description Get details for given user from CRM
   *
   */
  const getActiveSubmissions = () => {
    const axiosInstance = getInstance();

    return axiosInstance.post<IGetIndividualActiveSubmissionResponse>('/GetApplicationsIndividual/v1', {});
  };

  return {
    getUserDetails,
    getActiveSubmissions
  };
};

export default useUserService;